import React from 'react';
import {checkSupplierExist} from "../api";
import {ADD_NOTIFICATION} from "../store/action";
import firebase from 'firebase/compat/app'
import "firebase/compat/auth";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import {connect} from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import styled from "@material-ui/core/styles/styled";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        flexDirection: 'column',
    
    },
    title:{
    
    },
    googleButton: {
        backgroundColor: 'white',
        color: '#757575',
        padding: '0 24px',
        height: '40px',
        width:'150px',
        border: '1px solid #dadce0',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(60,64,67,.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Google Sans,Roboto,Arial,sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        letterSpacing: '.25px',
        '&:hover': {
            backgroundColor: '#f8f9fa',
            boxShadow: '0 1px 3px rgba(60,64,67,.12)',
        },
        '& img': {
            marginRight: '12px',
            width: '18px',
            height: '18px',
        }
    }
}))

const GoogleAuth = ({title, onFinish, dispatch, signupMode = false}) => {
    const [loading, setLoading] = React.useState(false);
    const classes = useStyles();
    const {t} = useTranslation()
    const handleError = (text) => {
        setLoading(false)
        dispatch({
            type: ADD_NOTIFICATION,
            payload: {
                type: 'error',
                text
            }
        })
    }

    const handleSignup = async (phoneNumber) => {
        setLoading(true)

            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().languageCode = 'es';
            firebase.auth()
  .signInWithPopup(provider)
  .then(async (result) => {
    /** @type {firebase.auth.OAuthCredential} */
    // The signed-in user info.
    var user = result.user;
    var email = user.email;
    var name = user.displayName;
    var phone = result.phoneNumber;
    const isSignup = user.metadata.creationTime === user.metadata.lastSignInTime
    const {data:{supplierExist}} = await checkSupplierExist(email)
    
    if(!signupMode && !supplierExist){
                handleError(t('user_doesnt_exist'))
                return
   
    }
    if(signupMode && supplierExist){
        handleError(t('user_exist'))
        return

}
        user.getIdToken().then(authToken => {
       onFinish({phone, authToken,email,name,isSignup})
        })
  }).catch((error) => handleError(error.message));
    }
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))


    return <div className={classes.root}>
        <Typography className={classes.title} color={'primary'} gutterBottom variant={'h4'}>{title}</Typography>
        <SignupWithGoogle loading={loading} handleNext={handleSignup}/>
        
    </div>
}

export default connect()(GoogleAuth);

const SignupWithGoogle = ({handleNext, loading}) => {
    const {t} = useTranslation()
    const classes = useStyles()

    return (
        <Button 
            className={classes.googleButton}
            onClick={() => handleNext()}
            disabled={loading}
        >
            {loading ? (
                <CircularProgress size={20} style={{ color: '#757575' }} />
            ) : (
                <>
                    <img 
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
                        alt="Google logo"
                    />
                    {t('sign-up-with-google')}
                </>
            )}
        </Button>
    )
}